export default __webpack_public_path__ + "static/media/P.0d782d5a.wav";